
const PreDepartureTestimonialData = [
    {
        id: 1,
        heading: "Visa Confidence Boost",
        text: "I was overwhelmed by the visa process until I found Holistic Learning’s toolkit. The checklist broke everything down step-by-step. I walked into my interview prepared—and walked out approved.",
        name: "Aisha, Saudi Arabia | Headed to Boston University"
    },
    {
        id: 2,
        heading: "Checklist = Calm",
        text: "I printed the checklist and stuck it on my wall. It covered things I hadn’t even thought of—like SIM cards, embassy contacts, and airport pickup. I felt calm, not chaotic, the week before flying.",
        name: "Zahra, UAE | Headed to University of Toronto"
    },
    {
        id: 3,
        heading: "No More Last-Minute Panic",
        text: "I used to rely on WhatsApp groups for packing advice. Holistic Learning’s checklist was way better—organized, Gulf-specific, and actually useful. I didn’t forget a single thing.",
        name: "Omar, Bahrain | Starting at Arizona State University"
    },
    {
        id: 4,
        heading: "Visa Interview Confidence",
        text: "The checklist helped me prep my visa folder perfectly. I walked into the embassy with everything in order—and walked out with approval. It was the most stress-free part of my journey.",
        name: "Layla, Saudi Arabia | Studying in Melbourne"
    },
    {
        id: 5,
        heading: "Shared It with My Cousins",
        text: "I downloaded the checklist and immediately sent it to my cousins. We’re all heading abroad this fall, and it made us feel like we had a plan. It’s now our go-to prep guide.",
        name: "Khalid, Oman | Enrolled at University of Leeds"
    },
    {
        id: 6,
        heading: "It’s More Than Packing",
        text: "This checklist isn’t just about what to pack—it’s about how to prepare mentally, culturally, and logistically. It helped me feel ready to start a new chapter abroad.",
        name: "Mariam, Kuwait | Pursuing Law in London"
    },
    
];

export default PreDepartureTestimonialData;